import Component from '../core/Component';

export default class SampleComponent extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        alert('test');
    }
}


// WEBPACK FOOTER //
// ./components/SampleComponent.js